'use client';
import { useThemeSetting } from '../../provider/index.js';
import { getColorStyles, safeArraySpread } from '../utils.js';
import { useBlock } from './useBlock.js';
/**
 * Returns the block style (if available)
 *
 * @param node DomNode
 * @returns
 */
export function useBlockColors(node) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const { name, attributes } = useBlock(node);
    const defaultColorsSettings = useThemeSetting('color.palette.default', null, []);
    const defaultGradientsSettings = useThemeSetting('color.palette.default', null, []);
    const themeColorsSettings = useThemeSetting('color.palette.theme', null, []);
    const themeGradientsSettings = useThemeSetting('color.palette.theme', null, []);
    const userColorsSettings = useThemeSetting('color.palette.user', null, []);
    const userGradientsSettings = useThemeSetting('color.palette.user', null, []);
    const blockColorsSettings = useThemeSetting('color.palette.theme', name, [], false);
    const blockGradientsSettings = useThemeSetting('color.gradients.theme', name, [], false);
    const allGradients = [
        ...safeArraySpread(blockGradientsSettings),
        ...safeArraySpread(userGradientsSettings),
        ...safeArraySpread(themeGradientsSettings),
        ...safeArraySpread(defaultGradientsSettings),
    ];
    const allColors = [
        ...safeArraySpread(blockColorsSettings),
        ...safeArraySpread(userColorsSettings),
        ...safeArraySpread(themeColorsSettings),
        ...safeArraySpread(defaultColorsSettings),
    ];
    const color = {
        backgroundColorSlug: '',
        backgroundColor: '',
        textColorSlug: '',
        textColor: '',
        gradientSlug: '',
        gradient: '',
        linkColorSlug: '',
        linkColor: '',
    };
    let foundInAttributes = false;
    if (attributes.backgroundColor) {
        foundInAttributes = true;
        color.backgroundColorSlug = attributes.backgroundColor;
        color.backgroundColor = (_a = allColors.find((c) => c.slug === attributes.backgroundColor)) === null || _a === void 0 ? void 0 : _a.color;
    }
    if (attributes.textColor) {
        foundInAttributes = true;
        color.textColorSlug = attributes.textColor;
        color.textColor = (_b = allColors.find((c) => c.slug === attributes.textColor)) === null || _b === void 0 ? void 0 : _b.color;
    }
    if (attributes.gradient) {
        foundInAttributes = true;
        color.gradientSlug = attributes.gradient;
        color.gradient = (_c = allGradients.find((c) => c.slug === attributes.gradient)) === null || _c === void 0 ? void 0 : _c.gradient;
    }
    if ((_g = (_f = (_e = (_d = attributes === null || attributes === void 0 ? void 0 : attributes.styleConfig) === null || _d === void 0 ? void 0 : _d.elements) === null || _e === void 0 ? void 0 : _e.link) === null || _f === void 0 ? void 0 : _f.color) === null || _g === void 0 ? void 0 : _g.text) {
        foundInAttributes = true;
        color.linkColorSlug =
            ((_m = (_l = (_k = (_j = (_h = attributes === null || attributes === void 0 ? void 0 : attributes.styleConfig) === null || _h === void 0 ? void 0 : _h.elements) === null || _j === void 0 ? void 0 : _j.link) === null || _k === void 0 ? void 0 : _k.color) === null || _l === void 0 ? void 0 : _l.text) === null || _m === void 0 ? void 0 : _m.split('|').pop()) || '';
        color.linkColor = (_o = allColors.find((c) => c.slug === color.linkColorSlug)) === null || _o === void 0 ? void 0 : _o.color;
    }
    if (!foundInAttributes) {
        return getColorStyles(node);
    }
    return color;
}
